import type { AdContent, AdType } from "@models/Ad.model";
import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";
import { httpRequest } from "../../http";

export type UpdateAdPayload = {
  name?: string;
  type?: AdType;
  subtype?: AdType;
  is_default?: boolean;
  is_template?: boolean;
  content?: AdContent;
  parent_id?: number | null;
  /** Not ad data: the user confirmed "edit anyway" on an approved/published ad, so the
   *  server skips the content lock for this request only. See AdLockedDialog. */
  force_edit?: boolean;
};

export class CommandUpdateAd {
  async run(adId: number, payload: UpdateAdPayload) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "PATCH",
        body: payload,
      });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error updating ad:", error);
      throw error;
    }
  }

  deserialize(data: any): Ad {
    const serializer = new AdSerializer();
    return serializer.deserialize(data);
  }
}
